import { Map as ImmutableMap, fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { createRpcClientV2 } from 'rpc-client-utils';
import { createFolderRpc, updateFolderRpc, deleteFolderRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsFoldersService';
export const baseUrl = 'presentations/v1/folders';
export const baseUrlV2 = 'presentations/v2/folders';
async function createFolderCHIRP(folder) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const request = {
    name: folder.get('name'),
    // TODO: App doesnt support embedding folders yet
    parentId: undefined
  };
  const response = await rpcClient.call(createFolderRpc, {
    request
  });
  return response;
}
export function createFolder(folder) {
  const isChirpEnabled = isUngatedToCHIRPEndpoints();
  return isChirpEnabled ? createFolderCHIRP(folder) : http.post(baseUrlV2, {
    data: folder
  }).then(fromJS);
}
async function updateFolderCHIRP(folder) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const request = {
    folderId: folder.get('contentId'),
    name: folder.get('name')
  };
  const response = await rpcClient.call(updateFolderRpc, {
    request
  });
  return response;
}
export function updateFolder(folder) {
  const isChirpEnabled = isUngatedToCHIRPEndpoints();
  const {
    contentId,
    name
  } = folder;
  return isChirpEnabled ? updateFolderCHIRP(folder) : http.put(`${baseUrlV2}/${contentId}`, {
    data: ImmutableMap({
      name,
      id: contentId
    })
  }).then(fromJS);
}
async function removeFolderCHIRP(folderId) {
  if (folderId === null) {
    throw new Error('Folder ID is required');
  }
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const request = {
    value: folderId
  };
  const response = await rpcClient.call(deleteFolderRpc, {
    request
  });
  return response;
}
export function removeFolder(folderId) {
  const isChirpEnabled = isUngatedToCHIRPEndpoints();
  return isChirpEnabled ? removeFolderCHIRP(folderId) : http.delete(`${baseUrl}/${folderId}`).then(fromJS);
}